/* eslint-disable */

/** unique or primary key constraints on table "argo.log_duration" */
export enum ArgoLogDurationConstraint {
  /** unique or primary key constraint on columns "level", "category" */
  LogDurationCategoryLevelUnique = 'log_duration_category_level_unique'
}

/** select columns of table "argo.log_duration" */
export enum ArgoLogDurationSelectColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Level = 'level',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "argo.log_duration" */
export enum ArgoLogDurationUpdateColumn {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Interval = 'interval',
  /** column name */
  Level = 'level',
  /** column name */
  Meta = 'meta',
  /** column name */
  UpdatedAt = 'updated_at'
}

